// extracted by mini-css-extract-plugin
module.exports = {"name":"Sidebar_name__2Sxte","lastComm":"Sidebar_lastComm__3P0Vk","btnWrapper":"Sidebar_btnWrapper__LbHp7","wrapper":"Sidebar_wrapper__1zYNw","closeIcon":"Sidebar_closeIcon__1fWnV"};